module.exports = __webpack_public_path__ + "static/media/edu_museum.63ab1cbe.webp";